import React, { useEffect, useState } from "react";
import NewTimer from "../../components/sendedOrders/newTimer";
import { FiBell } from "react-icons/fi";
import { MdPostAdd } from "react-icons/md";
import { colors } from "../../styles/style";
import useToSendedOrders from "../../hooks/useToSendedOrders";
import useToCancelOrders from "../../hooks/useToCancelOrders";
const ItemOrder = (props) => {
  const [hour, setHour] = useState("");
  const [idOrder, setIdOrder] = useState("");
  const [order, setOrder] = useState();
  const [totalReminders, setTotalReminders] = useState(0);
  //console.log("Datos de la orden", order?.reminders);
  const { sendReminder } = useToSendedOrders();
  const { sendCancelNotificacionToSeller } = useToCancelOrders();
  // We need ref in this, because we are dealing
  // with JS setInterval to keep track of it and
  // stop it when needed
  // The state for our timer
  useEffect(() => {
    setHour(props.hour);
    setIdOrder(props.idOrder);
    setOrder(props.order);
    checkReminders(props.order);
  }, [props]);

  function checkReminders(order) {
    if (order.reminders !== undefined) {
      let currentReminders = JSON.parse(order.reminders);
      if (currentReminders) {
        setTotalReminders(currentReminders.length);
      }
    }
  }

  return (
    <>
      {order && (
        <tr>
          <th scope="row"># {idOrder.substring(0, 6)}</th>
          <td className="text-center">
            {hour.substring(0, 10)} {hour.substring(11, 16)}
          </td>

          <td className="text-center">
            {hour && idOrder && order ? (
              <NewTimer orderID={idOrder} start={hour} order={order} />
            ) : null}
          </td>
          <td className="text-center">
            {order.shop_id != null ? order.shop_id.shop_name : "undefined"}
          </td>
          <td className="text-center">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => props.selectOrder(order)}
            >
              <div className="row">
                <MdPostAdd size={20} color={colors.WHITE_COLOR} />
              </div>
            </button>
          </td>
          <td className="text-center">
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => sendReminder(order, props.messageAssignOrder)}
              //onClick={() => sendCancelNotificacionToSeller(order)}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <FiBell
                  size={20}
                  style={{ marginRight: 10 }}
                  color={colors.BLACK_COLOR}
                />
                {totalReminders}
              </div>
            </button>
          </td>
        </tr>
      )}
    </>
  );
};

export default ItemOrder;
